/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiMediaUploaderProjectsParams,
  GetApiMediaUploaderProjectsProjectIdOrGuidFiles200Item,
  GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid200,
  GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl200,
  GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlParams,
  GetApiMediaUploaderProjectsProjectIdOrGuidFilesParams,
  MediaUploaderFileApiDTO,
  MediaUploaderProjectApiDTO,
  PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies,
  PostApiMediaUploaderProjectsApiBodies,
  PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




/**
 * Upsert a media uploader project.
Idempotent on guid, you can call this multiple times with the same guid and it will only create the project once, and update it if needed.
Return 201 if created, 200 if updated based on guid.
 */
export const postApiMediaUploaderProjects = (
    postApiMediaUploaderProjectsApiBodies: PostApiMediaUploaderProjectsApiBodies,
 ) => {
      
      
      return customInstance<MediaUploaderProjectApiDTO>(
      {url: `/api/media-uploader-projects`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiMediaUploaderProjectsApiBodies
    },
      );
    }
  


export const getPostApiMediaUploaderProjectsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMediaUploaderProjects>>, TError,{data: PostApiMediaUploaderProjectsApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiMediaUploaderProjects>>, TError,{data: PostApiMediaUploaderProjectsApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMediaUploaderProjects>>, {data: PostApiMediaUploaderProjectsApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiMediaUploaderProjects(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiMediaUploaderProjectsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMediaUploaderProjects>>>
    export type PostApiMediaUploaderProjectsMutationBody = PostApiMediaUploaderProjectsApiBodies
    export type PostApiMediaUploaderProjectsMutationError = ErrorType<unknown>

    export const usePostApiMediaUploaderProjects = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMediaUploaderProjects>>, TError,{data: PostApiMediaUploaderProjectsApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiMediaUploaderProjects>>,
        TError,
        {data: PostApiMediaUploaderProjectsApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiMediaUploaderProjectsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiMediaUploaderProjects = (
    params?: GetApiMediaUploaderProjectsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MediaUploaderProjectApiDTO[]>(
      {url: `/api/media-uploader-projects`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiMediaUploaderProjectsQueryKey = (params?: GetApiMediaUploaderProjectsParams,) => {
    return [`/api/media-uploader-projects`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiMediaUploaderProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjects>>, TError = ErrorType<unknown>>(params?: GetApiMediaUploaderProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjects>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMediaUploaderProjectsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMediaUploaderProjects>>> = ({ signal }) => getApiMediaUploaderProjects(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMediaUploaderProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMediaUploaderProjects>>>
export type GetApiMediaUploaderProjectsQueryError = ErrorType<unknown>

export const useGetApiMediaUploaderProjects = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjects>>, TError = ErrorType<unknown>>(
 params?: GetApiMediaUploaderProjectsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjects>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMediaUploaderProjectsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const patchApiMediaUploaderProjectsProjectIdOrGuid = (
    projectIdOrGuid: string,
    patchApiMediaUploaderProjectsProjectIdOrGuidApiBodies: PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies,
 ) => {
      
      
      return customInstance<MediaUploaderProjectApiDTO>(
      {url: `/api/media-uploader-projects/${projectIdOrGuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiMediaUploaderProjectsProjectIdOrGuidApiBodies
    },
      );
    }
  


export const getPatchApiMediaUploaderProjectsProjectIdOrGuidMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiMediaUploaderProjectsProjectIdOrGuid>>, TError,{projectIdOrGuid: string;data: PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiMediaUploaderProjectsProjectIdOrGuid>>, TError,{projectIdOrGuid: string;data: PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiMediaUploaderProjectsProjectIdOrGuid>>, {projectIdOrGuid: string;data: PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies}> = (props) => {
          const {projectIdOrGuid,data} = props ?? {};

          return  patchApiMediaUploaderProjectsProjectIdOrGuid(projectIdOrGuid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiMediaUploaderProjectsProjectIdOrGuidMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiMediaUploaderProjectsProjectIdOrGuid>>>
    export type PatchApiMediaUploaderProjectsProjectIdOrGuidMutationBody = PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies
    export type PatchApiMediaUploaderProjectsProjectIdOrGuidMutationError = ErrorType<unknown>

    export const usePatchApiMediaUploaderProjectsProjectIdOrGuid = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiMediaUploaderProjectsProjectIdOrGuid>>, TError,{projectIdOrGuid: string;data: PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiMediaUploaderProjectsProjectIdOrGuid>>,
        TError,
        {projectIdOrGuid: string;data: PatchApiMediaUploaderProjectsProjectIdOrGuidApiBodies},
        TContext
      > => {

      const mutationOptions = getPatchApiMediaUploaderProjectsProjectIdOrGuidMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiMediaUploaderProjectsProjectIdOrGuid = (
    projectIdOrGuid: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<MediaUploaderProjectApiDTO>(
      {url: `/api/media-uploader-projects/${projectIdOrGuid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiMediaUploaderProjectsProjectIdOrGuidQueryKey = (projectIdOrGuid: string,) => {
    return [`/api/media-uploader-projects/${projectIdOrGuid}`] as const;
    }

    
export const getGetApiMediaUploaderProjectsProjectIdOrGuidQueryOptions = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>, TError = ErrorType<unknown>>(projectIdOrGuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMediaUploaderProjectsProjectIdOrGuidQueryKey(projectIdOrGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>> = ({ signal }) => getApiMediaUploaderProjectsProjectIdOrGuid(projectIdOrGuid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectIdOrGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMediaUploaderProjectsProjectIdOrGuidQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>>
export type GetApiMediaUploaderProjectsProjectIdOrGuidQueryError = ErrorType<unknown>

export const useGetApiMediaUploaderProjectsProjectIdOrGuid = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>, TError = ErrorType<unknown>>(
 projectIdOrGuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuid>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMediaUploaderProjectsProjectIdOrGuidQueryOptions(projectIdOrGuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiMediaUploaderProjectsProjectIdOrGuidFiles = (
    projectIdOrGuid: string,
    postApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies: PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies,
 ) => {
      
      
      return customInstance<MediaUploaderFileApiDTO>(
      {url: `/api/media-uploader-projects/${projectIdOrGuid}/files`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies
    },
      );
    }
  


export const getPostApiMediaUploaderProjectsProjectIdOrGuidFilesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError,{projectIdOrGuid: string;data: PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError,{projectIdOrGuid: string;data: PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMediaUploaderProjectsProjectIdOrGuidFiles>>, {projectIdOrGuid: string;data: PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies}> = (props) => {
          const {projectIdOrGuid,data} = props ?? {};

          return  postApiMediaUploaderProjectsProjectIdOrGuidFiles(projectIdOrGuid,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiMediaUploaderProjectsProjectIdOrGuidFilesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMediaUploaderProjectsProjectIdOrGuidFiles>>>
    export type PostApiMediaUploaderProjectsProjectIdOrGuidFilesMutationBody = PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies
    export type PostApiMediaUploaderProjectsProjectIdOrGuidFilesMutationError = ErrorType<unknown>

    export const usePostApiMediaUploaderProjectsProjectIdOrGuidFiles = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError,{projectIdOrGuid: string;data: PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiMediaUploaderProjectsProjectIdOrGuidFiles>>,
        TError,
        {projectIdOrGuid: string;data: PostApiMediaUploaderProjectsProjectIdOrGuidFilesApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiMediaUploaderProjectsProjectIdOrGuidFilesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiMediaUploaderProjectsProjectIdOrGuidFiles = (
    projectIdOrGuid: string,
    params?: GetApiMediaUploaderProjectsProjectIdOrGuidFilesParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiMediaUploaderProjectsProjectIdOrGuidFiles200Item[]>(
      {url: `/api/media-uploader-projects/${projectIdOrGuid}/files`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiMediaUploaderProjectsProjectIdOrGuidFilesQueryKey = (projectIdOrGuid: string,
    params?: GetApiMediaUploaderProjectsProjectIdOrGuidFilesParams,) => {
    return [`/api/media-uploader-projects/${projectIdOrGuid}/files`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiMediaUploaderProjectsProjectIdOrGuidFilesQueryOptions = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError = ErrorType<unknown>>(projectIdOrGuid: string,
    params?: GetApiMediaUploaderProjectsProjectIdOrGuidFilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMediaUploaderProjectsProjectIdOrGuidFilesQueryKey(projectIdOrGuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>> = ({ signal }) => getApiMediaUploaderProjectsProjectIdOrGuidFiles(projectIdOrGuid,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectIdOrGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMediaUploaderProjectsProjectIdOrGuidFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>>
export type GetApiMediaUploaderProjectsProjectIdOrGuidFilesQueryError = ErrorType<unknown>

export const useGetApiMediaUploaderProjectsProjectIdOrGuidFiles = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError = ErrorType<unknown>>(
 projectIdOrGuid: string,
    params?: GetApiMediaUploaderProjectsProjectIdOrGuidFilesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFiles>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMediaUploaderProjectsProjectIdOrGuidFilesQueryOptions(projectIdOrGuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl = (
    projectIdOrGuid: string,
    idOrGuid: string,
    params: GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl200>(
      {url: `/api/media-uploader-projects/${projectIdOrGuid}/files/${idOrGuid}/uploadSignedUrl`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlQueryKey = (projectIdOrGuid: string,
    idOrGuid: string,
    params: GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlParams,) => {
    return [`/api/media-uploader-projects/${projectIdOrGuid}/files/${idOrGuid}/uploadSignedUrl`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlQueryOptions = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>, TError = ErrorType<unknown>>(projectIdOrGuid: string,
    idOrGuid: string,
    params: GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlQueryKey(projectIdOrGuid,idOrGuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>> = ({ signal }) => getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl(projectIdOrGuid,idOrGuid,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectIdOrGuid && idOrGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>>
export type GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlQueryError = ErrorType<unknown>

export const useGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>, TError = ErrorType<unknown>>(
 projectIdOrGuid: string,
    idOrGuid: string,
    params: GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrl>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidUploadSignedUrlQueryOptions(projectIdOrGuid,idOrGuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid = (
    projectIdOrGuid: string,
    idOrGuid: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid200>(
      {url: `/api/media-uploader-projects/${projectIdOrGuid}/files/${idOrGuid}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidQueryKey = (projectIdOrGuid: string,
    idOrGuid: string,) => {
    return [`/api/media-uploader-projects/${projectIdOrGuid}/files/${idOrGuid}`] as const;
    }

    
export const getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidQueryOptions = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>, TError = ErrorType<unknown>>(projectIdOrGuid: string,
    idOrGuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidQueryKey(projectIdOrGuid,idOrGuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>> = ({ signal }) => getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid(projectIdOrGuid,idOrGuid, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(projectIdOrGuid && idOrGuid), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>>
export type GetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidQueryError = ErrorType<unknown>

export const useGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid = <TData = Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>, TError = ErrorType<unknown>>(
 projectIdOrGuid: string,
    idOrGuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuid>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMediaUploaderProjectsProjectIdOrGuidFilesIdOrGuidQueryOptions(projectIdOrGuid,idOrGuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



